// src/components/TopNav/SaveButton.jsx
import { useState } from 'react'
import { CheckIcon, CloudArrowUpIcon } from '@heroicons/react/24/outline'
import Spinner from '../Shared/Spinner'

export default function SaveButton({ onClick, isSaved }) {
  const [isSaving, setIsSaving] = useState(false)
  const [justSaved, setJustSaved] = useState(false)

  const handleSave = async () => {
    try {
      setIsSaving(true)
      await onClick()
      setJustSaved(true)

      // Reset highlight ring after a short time
      setTimeout(() => setJustSaved(false), 2000)
    } finally {
      setIsSaving(false)
    }
  }

  return (
    <button
      onClick={handleSave}
      aria-label="Save recipe"
      title="Click to save manually (auto-save also enabled)"
      className={`
        ml-4 px-3 py-1.5 rounded text-sm font-medium flex items-center gap-1
        ${isSaved ? 'text-green-600' : 'text-deep-blue'} 
        bg-white hover:bg-soft-yellow/40 
        border border-gray-300 shadow-sm
        transition-all duration-200
        ${justSaved ? 'ring-2 ring-green-300' : ''}
        focus:outline-none focus-visible:ring-2 focus-visible:ring-green-400
      `}
      aria-live="polite"
    >
      {isSaving ? (
        <>
          <Spinner size="sm" className="text-green-600" />
          Saving…
        </>
      ) : isSaved ? (
        <>
          <CheckIcon className="w-4 h-4" />
          Saved
        </>
      ) : (
        <>
          <CloudArrowUpIcon className="w-4 h-4" />
          Save
        </>
      )}
    </button>
  )
}